import type { FaireProductEntity } from "../../entity_types/product";

export const p_755rxfhuzv: FaireProductEntity = {
  token: "p_755rxfhuzv",
  type: "product",
  name: "Teacher Pencils Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/cd2db5a96893d9b2801b8147b694a209cfa421d18aa8f9f4526c5f28eded576e.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a6cdf482eeb3001bd12e17aa72dca89fadcb1503f4607c917b3929c1557eb0ed.png",
    "https://cdn.faire.com/fastly/74ab1cd9106044f417b52f0e044809290a67c60ba1caf2733f3d7dce8df65fb0.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:01.878Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
